import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import {
  VendorDetails,
  TParams,
  VendorDetailsWithContractAdmin,
  VendorWithAdminCreationRequestData,
  TVendorNamesCheckResponse
} from './types'

const fetcher = new Fetcher({})

export const getVendorDetailsRequestAsync = async (id: string) =>
  fetcher.request<unknown, VendorDetailsWithContractAdmin>({
    url: `${API_DICTIONARY.VENDORS}${id}/for_community/`,
    method: HTTP_METHODS.GET
  })

export const createVendorWithAdminRequestAsync = async (
  data: VendorWithAdminCreationRequestData
) =>
  fetcher.request<VendorWithAdminCreationRequestData, VendorDetails>({
    url: `${API_DICTIONARY.VENDORS}`,
    method: HTTP_METHODS.POST,
    data
  })

export const checkVendorName = async (params: TParams) =>
  fetcher.request<unknown, TVendorNamesCheckResponse>({
    url: `${API_DICTIONARY.VENDORS}${API_DICTIONARY.SEARCH}`,
    method: HTTP_METHODS.GET,
    params
  })
export const checkVendorLegalName = async (params: TParams) =>
  fetcher.request<unknown, TVendorNamesCheckResponse>({
    url: `${API_DICTIONARY.VENDORS}${API_DICTIONARY.SEARCH}${API_DICTIONARY.NAME}`,
    method: HTTP_METHODS.GET,
    params
  })

export const checkVendorAlternateName = async (params: TParams) =>
  fetcher.request<unknown, TVendorNamesCheckResponse>({
    url: `${API_DICTIONARY.VENDORS}${API_DICTIONARY.SEARCH}${API_DICTIONARY.ALTERNATE_NAME}`,
    method: HTTP_METHODS.GET,
    params
  })
